<template>
  <!--多选设备选择-->
  <div class="deviceSelectModule">
    <el-dialog v-model="deviceVisible" :close-on-click-modal="false" class="bindDialog" title="选择设备" width="70%">
      <div class="dialogCont">
        <div class="leftBox">
          <div class="head">待选项:</div>
          <div class="leftBoxCont">
            <div class="transferContentLeft">
              <el-tree ref="treeRef" :check-strictly="true" :current-node-key="currentNodeKey"
                       :data="customerList" :default-expanded-keys="defaultExpandKeys" :expand-on-click-node="false"
                       :load="treeList" :props="{label: 'name',children: 'subList',isLeaf:'noExistSub'}" lazy
                       node-key="id" show-checkbox @node-click="handleNodeClick" @check-change="handleNodeChange">
              </el-tree>
            </div>
            <div class="transferContRight">
              <el-popover :visible="checkAllVisible" :width="224" placement="top">
                <div style="width: 200px;height: 86px;padding: 12px;box-sizing: border-box;">
                  <div style="display:flex;align-items: center;">确定要将设备全部添加到应用中吗？</div>
                  <div style="display:flex;justify-content: end;height: 32px;">
                    <el-button size="small" @click="checkAllVisible = false">取消</el-button>
                    <el-button size="small" type="primary" @click="equipmentSelectAllClick">确定</el-button>
                  </div>
                </div>
                <template #reference>
                  <!--                  <p @click="checkAllVisible=true">全选</p>-->
                  <el-button type="primary" @click="checkAllVisible=true">全选</el-button>
                </template>
              </el-popover>
              <p v-for="(item,index) in equipmentSelectList" :key="index"
                 :style="{cursor:item.enableFlag==1?'no-drop':'pointer'}"
                 @click="addEquipmentFun(item)">
                {{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div class="head">已选中的设备:</div>
          <div class="deviceBox">
            <p v-for="(item,index) in checkList" :key="index">
              <span>{{ item.value }}</span>
              <el-icon @click="delEquipmentFun(index)">
                <CircleCloseFilled/>
              </el-icon>
            </p>
          </div>
        </div>
      </div>
      <template #footer>
				<span class="dialog-footer">
		    		<el-button class="resetButton" @click="deviceVisible = false">取消</el-button>
		    		<el-button type="primary" @click="addDeviceFun">添加</el-button>
      			</span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {defineProps, nextTick, onMounted, ref, watch} from "vue"
import qs from "qs";
import {ElMessage} from "element-plus";
import {getTreePrefix} from "@/api/modules/dataSearch";
import {getProjectSubTreeApi, getProjectTopTreeApi} from "@/api/modules/project";

const props = defineProps(['deviceVisible', 'checkDeviceList'])
const emit = defineEmits(['deviceVisibleFun', 'checkDeviceListFun']);
const deviceVisible = ref()


// 绑定设备操作-------------------------------------------------------------------
// 点击新增设备
let checkList = ref([])   //选中的设备
let dialogVisible = ref(false)  //时间段弹窗
// 点击添加
const addEquipmentFun = function (item) {
  let flag = false
  for (let i = 0; i < checkList.value.length; i++) {
    if (checkList.value[i].key === item.id) {
      flag = true
    }
  }
  if (!flag) {
    checkList.value.push({
      key: item.id,
      value: item.name
    })
  } else {
    ElMessage({
      type: 'info',
      message: '该设备已选中'
    })
  }
}
const delEquipmentFun = function (idx) {
  checkList.value.splice(idx, 1)
  let arr = []
  for (let i = 0; i < checkList.value.length; i++) {
    if (checkList.value[i].key.includes('p')) {
      arr.push(checkList.value[i].key)
    }
  }
  treeRef.value.setCheckedKeys(arr)
}
// 全选应用设备
let checkAllVisible = ref(false)
const equipmentSelectAllClick = function () {
  for (let i = 0; i < equipmentSelectList.value.length; i++) {
    addEquipmentFun(equipmentSelectList.value[i])
  }
  checkAllVisible.value = false
}
// 点击将设备添加到选择框内
const addDeviceFun = function () {
  dialogVisible.value = false
  emit('deviceVisibleFun', false)
  emit('checkDeviceListFun', checkList.value)
}
// 树级列表
let custerObj = ref({}) //当前项目信息
let currentNodeKey = ref() //默认选中树级列表第一级
let defaultExpandKeys = ref() //默认选中树级列表第一级
let treeRef = ref()
let customerList = ref([])
//获取项目树级列表
const getProjectListFun = async function () {
  await getTreePrefix(qs.stringify({
    id: 0,
  })).then(res => {
    if (res.data.code === 0) {
      customerList.value = res.data.result
      defaultExpandKeys.value = [customerList.value[0].id]
      //有无路由参数
      currentNodeKey.value = customerList.value[0].id
      custerObj.value = customerList.value[0]
      let arr = []
      for (let i = 0; i < checkList.value.length; i++) {
        if (checkList.value[i].key.includes('p')) {
          arr.push(checkList.value[i].key)
        }
      }
      nextTick(() => {
        if (treeRef.value) {
          treeRef.value.setCurrentKey(currentNodeKey.value)
          treeRef.value.setCheckedKeys(arr)
        }
      })
      getEquipmentSelectFun()
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 项目树懒加载-------------------
const treeList = async function (node, resolve) {
  if (node.level === 0) {
    await getProjectTopTreeApi().then(res => {
      if (res.data.code === 0) {
        handleNodeClick(res.data.result)
        defaultExpandKeys.value = [res.data.result.id]
        currentNodeKey.value = res.data.result.id
        return resolve([res.data.result])
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  } else if (node.level === 1) {
    await getProjectTopTreeApi().then(res => {
      if (res.data.code === 0) {
        return resolve(res.data.result.subList)
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  } else {
    await getProjectSubTreeApi(qs.stringify({id: node.data.id})).then(res => {
      if (res.data.code === 0) {
        return resolve(res.data.result)
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }

}
// 项目树点击
const handleNodeClick = function (e) {
  custerObj.value = e
  currentNodeKey.value = e.id
  defaultExpandKeys.value = []
  defaultExpandKeys.value.push(e.parentId)
  getEquipmentSelectFun()
}
// 项目树选择
const handleNodeChange = function (node, flag) {
  if (flag) {
    let flagCopy = true
    for (let i = 0; i < checkList.value.length; i++) {
      if (checkList.value[i].key === node.id) {
        flagCopy = false
      }
    }
    if (flagCopy) {
      checkList.value.push({
        key: node.id,
        value: node.name
      })
    }
  } else {
    for (let i = 0; i < checkList.value.length; i++) {
      if (checkList.value[i].key === node.id) {
        checkList.value.splice(i, 1)
      }
    }
  }
}
// 根据项目获取设备选项
let equipmentSelectList = ref([])
const getEquipmentSelectFun = function () {
  getTreePrefix(qs.stringify({
    id: custerObj.value.idStr,
  })).then(res => {
    if (res.data.code === 0) {
      equipmentSelectList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


watch(() => props.deviceVisible, (newVal) => {
  deviceVisible.value = newVal
  // getProjectListFun()
}, {immediate: true, deep: true})
watch(() => props.checkDeviceList, (newVal) => {
  checkList.value = JSON.parse(JSON.stringify(newVal))
}, {immediate: true, deep: true})
watch(() => deviceVisible.value, (newVal) => {
  deviceVisible.value = newVal
  emit('deviceVisibleFun', newVal)
})
onMounted(() => {
  // getProjectListFun()
})
</script>

<style lang="less" scoped>
.deviceSelectModule {
  .el-dialog {
    .dialogCont {
      display: flex;
      justify-content: space-between;
      min-height: 300px;

      .leftBox, .rightBox {
        flex: 1;
        border-radius: 3px;
        border: 1px solid #DDDDDD;
      }

      .leftBox {
        margin-right: 10px;

        .head {
          width: 100%;
          height: 48px;
          background: #F5F7FA;
          border-radius: 3px 3px 0px 0px;
          border: 1px solid #EEEEEE;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
          line-height: 48px;
          text-indent: 16px;
        }

        .leftBoxCont {
          width: 100%;
          height: calc(100% - 52px);
          display: flex;
          justify-content: space-between;


          .transferContentLeft {
            flex: 1;
            min-width: 200px;
            padding: 10px;
            overflow: auto;
            border-right: 1px solid #eee;

            .el-tree-node__content {
              height: 40px;

              .opacityIcon {
                display: none;
              }
            }

            .el-tree-node__content:hover {
              background-color: #F6F7F7;

              .opacityIcon {
                display: inline-flex;
              }
            }

            /*选中颜色*/

            .el-tree-node.is-current > .el-tree-node__content {
              background-color: rgba(22, 93, 255, 0.1);
              color: #165DFF;

              .el-icon {
                color: #165DFF;
              }
            }

            .el-tree {
              --el-tree-expand-icon-color: #000;
              color: #000;
            }

          }

          .transferContRight {
            flex: 1;
            padding: 10px;
            overflow: auto;
            min-width: 200px;

            p {
              width: 100%;
              height: 32px;
              line-height: 32px;
              text-indent: 10px;
              white-space: nowrap;
              cursor: pointer;
            }

            p:hover {
              background-color: rgba(22, 93, 255, 0.1);
            }
          }
        }
      }


      .rightBox {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;

        .head {
          width: 100%;
          height: 48px;
          background: #F5F7FA;
          border-radius: 3px 3px 0px 0px;
          border: 1px solid #EEEEEE;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
          line-height: 48px;
          text-indent: 16px;
        }

        .deviceBox {
          padding: 16px;

          p {
            display: inline-block;
            padding: 1px 8px;
            background: #EBEDF0;
            border-radius: 3px;
            margin-right: 10px;
            margin-bottom: 10px;

            .el-icon {
              margin-left: 5px;
              transform: translateY(2px);
              color: #999999;
              cursor: pointer;
            }
          }
        }
      }

      > .deviceBox {

        p {
          display: inline-block;
          padding: 1px 8px;
          background: #EBEDF0;
          border-radius: 3px;
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }

    }
  }


  .bindDialog {
    margin-top: 5vh;
    max-height: 90vh;

    .leftBox, .rightBox {
      max-height: calc(90vh - 200px);
    }
  }
}
</style>
